import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";

import PageConfig from "../../config";

const { LEGEND_DATE_FORMAT } = PageConfig;

const DailySalesDataTable = ({
  tableData,
  avgNextMonthNewAds,
  avgNextMonthRenewAds,
}) => {
  const getClassNameByAverage = ({ currentValue, averageValue }) => {
    if (currentValue > averageValue) return "above-avg";
    if (currentValue < averageValue) return "below-avg";
    return "at-avg";
  };

  return (
    <TableContainer className="table-container flex-1">
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell className="font-bold text-center">Date</TableCell>
            <TableCell className="font-bold text-center">New Ads</TableCell>
            <TableCell className="font-bold text-center">Renewals</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="table-body">
          {tableData.map(({ date, new: newAds, renew }) => (
            <TableRow key={date}>
              <TableCell className="text-center">
                {moment(date).format(LEGEND_DATE_FORMAT)}
              </TableCell>
              <TableCell
                className={`text-center ${getClassNameByAverage({
                  currentValue: newAds,
                  averageValue: avgNextMonthNewAds,
                })}`}
              >
                {newAds}
              </TableCell>
              <TableCell
                className={`text-center ${getClassNameByAverage({
                  currentValue: renew,
                  averageValue: avgNextMonthRenewAds,
                })}`}
              >
                {renew}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DailySalesDataTable;
